export default __webpack_public_path__ + "static/media/image4.2b2eac1b.jpeg";